/*
 * المفضلة.
 *
 * كان هذا الملف يعرّف window.Wishlist داخل معالج DOMContentLoaded،
 * و footer-js.liquid ينادي Wishlist.init() من معالج DOMContentLoaded ثاني.
 * يعني ملفين يعتمدون على ترتيب تسجيل المعالجات بينهما — وهذا سبب
 * خطأ "Wishlist is not defined".
 *
 * الحل: الملف يهيّئ نفسه بنفسه بآخر الـ IIFE، والنداء الخارجي انحذف.
 * ما بقى أي اعتماد على ترتيب بين الملفين.
 */

addEventListener('DOMContentLoaded', function () {

  if (typeof jQuery === 'undefined') return;

  ;(function (Wishlist, $) {

    var $wishlistButton = $('.wishlist-btn');
    var $wishlistTile = $('.wishlist-tile-container');
    var $wishlitcounter = $('.wishlist-counter');
    var numProductTiles = $wishlistTile.length;

    var iconMarkup =
      '<span class="add-wishlist"><i class="ri-heart-line"></i></span>' +
      '<span class="loading-wishlist load-anim"><i class="ri-loader-4-line"></i></span>' +
      '<span class="remove-wishlist"><i class="ri-heart-fill"></i></span>';

    /* قراءة محصّنة: لو انخربت القيمة بالتخزين المحلي ما نرمي استثناء */
    var wishlist = [];

    try {
      var raw = localStorage.getItem('user_wishlist');
      if (raw) {
        var parsed = JSON.parse(raw);
        if (Object.prototype.toString.call(parsed) === '[object Array]') {
          wishlist = parsed;
        }
      }
    } catch (err) {
      wishlist = [];
    }

    function readCount() {
      var stored = localStorage.getItem('user_wishlist_count');
      var value = parseInt(stored, 10);
      return isNaN(value) ? 0 : Math.max(value, 0);
    }

    function writeCount(value) {
      var safe = Math.max(value, 0);
      localStorage.setItem('user_wishlist_count', safe);
      $wishlitcounter.html(safe);
    }

    function persist() {
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
    }

    $wishlitcounter.html(readCount());

    /* تبديل الحالة المرئية للزر */
    var animateWishlist = function (self) {
      $(self).toggleClass('is-active');
    };

    /* إضافة أو حذف المنتج من قائمة المفضلة */
    var updateWishlist = function (self) {
      var productHandle = $(self).attr('data-product-handle');
      var isRemove = $(self).hasClass('is-active');

      if (!productHandle) return;

      if (isRemove) {
        var removeIndex = wishlist.indexOf(productHandle);
        if (removeIndex > -1) wishlist.splice(removeIndex, 1);
        writeCount(readCount() - 1);
      } else {
        if (wishlist.indexOf(productHandle) === -1) wishlist.push(productHandle);
        writeCount(readCount() + 1);
      }

      persist();

      if ($(self).find('span').length !== 0) {
        $wishlistButton.html(iconMarkup);
      }
    };

    /* تفعيل الأزرار للمنتجات الموجودة أصلاً بالمفضلة */
    var activateItemsInWishlist = function () {
      $wishlistButton.each(function () {
        var productHandle = $(this).attr('data-product-handle');

        if (wishlist.indexOf(productHandle) > -1) {
          $(this).addClass('is-active');

          if ($(this).find('span').length !== 0) {
            $(this).html(iconMarkup);
          }
        }
      });
    };

    var displayOnlyWishlistItems = function () {
      $wishlistTile.each(function () {
        var productHandle = $(this).attr('data-product-handle');

        if (wishlist.indexOf(productHandle) === -1) {
          $(this).remove();
          numProductTiles--;
        }
      });
    };

    /* صفحة المفضلة: نخفي كل شي ما هو بالقائمة */
    var loadWishlist = function () {
      if (window.location.href.indexOf('pages/wishlist') === -1) return;

      displayOnlyWishlistItems();

      $('.wishlist-loader').fadeOut(600, function () {
        $('.wishlist-grid').addClass('is_visible');
        $('.wishlist-hero').addClass('is_visible');

        if (numProductTiles === 0) {
          $('.wishlist-grid-empty-list').addClass('is_visible');
          $('.wishlist-grid').hide();
        } else {
          $('.wishlist-grid-empty-list').hide();
        }
      });
    };

    var bindUIActions = function () {
      $wishlistButton.on('click.wishlist', function (e) {
        e.preventDefault();
        updateWishlist(this);
        animateWishlist(this);
      });

      /*
       * مسح الكل.
       * النسخة القديمة كانت تستخدم $(self) و self هنا هو window،
       * فالـ productHandle يطلع undefined والدالة ما تمسح شي — وترمي
       * استثناء لو كان التخزين فارغ. المسح الكامل لا يحتاج حلقة أصلاً.
       */
      $('#remove-done').on('click.wishlist', function (e) {
        e.preventDefault();

        wishlist = [];
        persist();
        writeCount(0);

        location.reload();
      });
    };

    Wishlist.init = function () {
      bindUIActions();
      activateItemsInWishlist();
      loadWishlist();
    };

    /* التهيئة الذاتية — ما عاد فيه نداء خارجي من footer-js */
    Wishlist.init();

  }(window.Wishlist = window.Wishlist || {}, jQuery, undefined));

  /* كانت معرّفة داخل المعالج فما كانت توصل لـ onclick بالماركأب */
  window.reloadPage = function () {
    location.reload();
  };

});
